import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, ChevronDown, ChevronUp, Menu } from "lucide-react";
import { Home, Layers, Settings, Bell, BarChart, Users, MapPin, UserCheck } from "lucide-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Box, Divider } from "@mui/material";
import "./sidebar.css";
const Sidebar = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menus, setMenus] = useState([]);
  const [openMenus, setOpenMenus] = useState({}); // track which menu is open

  const DJANGO_API = process.env.REACT_APP_API_DJANGO_URL;
  const roleMap = { SA: "superadmin", TTA: "ttadmin", A: "admin", S: "supervisor", SE: "site_engineer", O: "organization",CA:"customer_admin",DC:"demo_customer"};
  const roleCode = localStorage.getItem("role");
  const roleName = roleMap[roleCode];

  // Mapping of menu codes to icons
  const menuIcons = {
    overview: <Layers size={18} />,
    dashboard: (
      <Box component="img" src={process.env.PUBLIC_URL + "/Home.png"} sx={{ width: 20, height: 20 }} />
    ),
    master: (
      <Box component="img" src={process.env.PUBLIC_URL + "/Gear.png"} sx={{ width: 20, height: 20 }} />
    ),
    alarms: (
      <Box component="img" src={process.env.PUBLIC_URL + "/Alarm.png"} sx={{ width: 20, height: 20 }} />
    ),
    reports: (
      <Box component="img" src={process.env.PUBLIC_URL + "/Analytics.png"} sx={{ width: 20, height: 20 }} />
    ),

  };

  const menuIconsActive = {
  dashboard: "/Home2.png",
  master: "/Gear2.png",
  alarms: "/Alarm2.png",
  reports: "/Analytics2.png",
};



  useEffect(() => {
    const fetchMenusAndSubmenus = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token || !roleName) return;

      try {
        const menuResp = await fetch(`${DJANGO_API}/api/get-menus/?role=${roleCode}`, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        if (!menuResp.ok) return;
        const menuData = await menuResp.json();

        const submenuResp = await fetch(`${DJANGO_API}/api/get-submenus/?role=${roleCode}`, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const submenuData = submenuResp.ok ? await submenuResp.json() : [];

        const menusWithSub = menuData.map((menu) => ({
          ...menu,
          submenus: submenuData.filter((sub) => sub.menu_id === menu.id),
        }));

        setMenus(menusWithSub);
      } catch (error) {
        console.error("Error fetching menus/submenus:", error);
      }
    };

    fetchMenusAndSubmenus();
  }, [DJANGO_API, roleCode, roleName]);

  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
  };

 const handleLogout = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    if (token) {
      await fetch(`${DJANGO_API}/api/logout/`, {
        method: "POST",
        headers: { "X-Cloud-Token": token },
      });
    }
  } catch (error) {
    console.error("Logout failed:", error);
  } finally {
    localStorage.clear();
    navigate("/", { replace: true });
  }
};

  const isActiveMenu = (menu) =>
  location.pathname === menu.path ||
  menu.submenus?.some((sub) => sub.path === location.pathname);

  return (

    <>
    <div className="collapse-icon" onClick={() => setCollapsed(!collapsed)}>
  <Menu size={24} />
</div>

     
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
     {/* Collapse Icon */}
      <div className="collapse-icon" onClick={() => setCollapsed(!collapsed)}>
        <Menu size={24} />
      </div>

      {/* <div className="collapse-icon" onClick={() => setCollapsed(!collapsed)}>
  {collapsed ? <ChevronRight size={24} /> : <ChevronLeft size={24} />}
</div> */}

      {/* Sidebar content */}
      <div className="sidebar-main">
        {/* Logo */}
        {!collapsed && (
          <div
            className="logo-section"
            style={{ display: "flex", justifyContent: "center", marginBottom: "-30px" }}
          >
            <Box
              component="img"
              src={process.env.PUBLIC_URL + "/IgnisVigilLogo_2.png"}
              alt="Logo"
              sx={{ width: 210, height: "100px", mt: -2 }}
            />
          </div>
        )}


        {/* Menu List */}
        <ul className="menu-list" style={{ marginTop: 5, paddingTop: 50 }}>
          {menus.map((menu, index) => {
            const hasSub = menu.submenus && menu.submenus.length > 0;
            const isOpen = openMenus[menu.id];

            return (

              <li
                key={menu.id}
                style={{
                  borderBottom: "1px solid #0075FF",
                  // ADDED THIS LINE:
                  borderTop: index === 0 ? "1px solid #0075FF" : "none"
                }}
              >
                <div
                  className={`menu-link ${
  location.pathname === menu.path ||
  menu.submenus?.some((sub) => sub.path === location.pathname)
    ? "active"
    : ""
}`}
                  onClick={() => (hasSub ? toggleMenu(menu.id) : navigate(menu.path))}
                  style={{
                    cursor: hasSub ? "pointer" : "default",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                   {isActiveMenu(menu) ? (
  <Box
    component="img"
    src={process.env.PUBLIC_URL + (menuIconsActive[menu.code] || "")}
    sx={{ width: 30, height: 30 }}
  />
) : (
  menuIcons[menu.code]
)}
                    {!collapsed && menu.name}
                  </span> */}
                  <span
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    justifyContent: collapsed ? "center" : "flex-start",
  }}
>
  {isActiveMenu(menu) ? (
    <Box
      component="img"
      src={process.env.PUBLIC_URL + (menuIconsActive[menu.code] || "")}
      sx={{ width: 30, height: 30 }}
    />
  ) : (
    menuIcons[menu.code]
  )}

  {!collapsed && <span className="menu-text">{menu.name}</span>}
</span>
                  {hasSub && !collapsed && (isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />)}
                </div>

                {/* Submenu */}
                {hasSub && isOpen && !collapsed && (
                  <ul className="submenu">
                    {menu.submenus.map((sub) => (
                      <li key={sub.id} className="submenu-item">
                        <span
                          onClick={() => navigate(sub.path)}
                          style={{
                            color: "black",
                            cursor: "pointer",
                            textDecoration: "none",
                            display: "block",
                            padding: "5px 0",
                          }}
                        >
                          {sub.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      {/* Footer */}
     <div className="sidebar-footer">
  <button className="logout-btn" onClick={handleLogout}>
    <LogOut size={20} />
    {!collapsed && <span>Logout</span>}
  </button>
</div>
    </div>
    </>
  );
};

export default Sidebar;